import { textString, buttonString } from './texts.js';
import Logger from './logger.js';

class CoverDialog {
    static instance = null;

    customizerContentDiv = null;
    wrapperDiv = null;

    /**
     * Initialisera CoverDialog singleton med parent element
     * Denna metod anropas av popup.js under setup
     * @param {HTMLElement} customizerContentDiv - Parent element
     */
    static init(customizerContentDiv) {
        if (!CoverDialog.instance) {
            CoverDialog.instance = new CoverDialog(customizerContentDiv);
        }
    }

    /**
     * Visa dialogen med options
     * @param {Object} options - Configuration
     * @param {string} options.title - Text key for title (e.g., 'invalidResolution_title')
     * @param {string} options.message - Text key for message (e.g., 'invalidResolution_message')
     * @param {Object} options.data - Data object with named placeholders (e.g., { size: '40x50', orientation: 'portrait' })
     * @param {Function} options.onClose - Callback when dialog is closed
     */
    static async show(options = {}) {
        if (!CoverDialog.instance) {
            Logger.error('CoverDialog not initialized. Call CoverDialog.init() first.');
            return;
        }
        await CoverDialog.instance.show(options);
    }

    /**
     * @param {HTMLElement} customizerContentDiv - Parent element
     */
    constructor(customizerContentDiv) {
        this.customizerContentDiv = customizerContentDiv;

        if (!this.customizerContentDiv) {
            Logger.error('CoverDialog failed to load.');
            return;
        }
        this.createWrapper();
    }

    /**
     * Ersätt [[nyckel]] placeholders med data från objekt
     * @param {string} text - Text with [[key]] placeholders
     * @param {Object} data - Object med nyckel => värde mappnings
     * @returns {string}
     */
    replacePlaceholders(text, data) {
        if (!data || typeof data !== 'object') {
            return text;
        }
        let result = text;
        Object.entries(data).forEach(([key, value]) => {
            const placeholder = `[[${key}]]`;
            result = result.replaceAll(placeholder, value);
        });
        return result;
    }

    async createWrapper() {
        if (this.wrapperDiv) {
            return;
        }

        this.wrapperDiv = document.createElement('div');
        this.wrapperDiv.classList.add('mscp-cover-dialog-wrapper');
        this.customizerContentDiv.appendChild(this.wrapperDiv);
    }

    /**
     * Visa dialogen med options
     * @param {Object} options - Configuration
     * @param {string} options.type - Text key for title (e.g., 'invalidResolution_title')
     * @param {Array} options.data - Data array to replace %s placeholders in message
     * @param {Function} options.onClose - Callback when dialog is closed
     */
    async show(options = {}) {
        if (!this.wrapperDiv) {
            await this.createWrapper();
        }

        // Rensa tidigare innehål
        this.wrapperDiv.innerHTML = '';

        // Titel
        const title = document.createElement('h2');
        title.textContent = textString(`${options.type}_title`);
        this.wrapperDiv.appendChild(title);

        // Meddelande/beskrivning - med data-ersättning
        const messageDiv = document.createElement('div');
        messageDiv.classList.add('mscp-cover-dialog-message');
        let messageText = textString(`${options.type}_message`);
        // Ersätt [[nyckel]] med data från objekt
        messageText = this.replacePlaceholders(messageText, options.data);
        messageDiv.innerHTML = messageText;
        this.wrapperDiv.appendChild(messageDiv);

        // Knapp-wrapper
        const buttonWrapperDiv = document.createElement('div');
        buttonWrapperDiv.classList.add('mscp-cover-dialog-buttons');

        // Stäng-knapp
        const closeButtonText = buttonString('coverPopup_close_button', 'Close');
        const closeButtonDiv = document.createElement('button');
        closeButtonDiv.classList.add('mscp-cover-dialog-button', 'mscp-button');
        closeButtonDiv.innerHTML = closeButtonText;
        buttonWrapperDiv.appendChild(closeButtonDiv);

        this.wrapperDiv.appendChild(buttonWrapperDiv);

        // Event listener för stäng-knapp
        closeButtonDiv.addEventListener('click', () => {
            this.hide();
            if (typeof options.onClose === 'function') {
                options.onClose();
            }
        });

        // Visa dialogen
        this.customizerContentDiv.classList.add('cover-dialog-active');
        this.customizerContentDiv.scrollTop = 0;
    }

    /**
     * Dölj dialogen
     */
    hide() {
        if (this.customizerContentDiv) {
            this.customizerContentDiv.classList.remove('cover-dialog-active');
        }
    }
}

export default CoverDialog;